import React, { useEffect, startTransition } from "react"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { logoutUser } from "store/slices/authSlice"
import { endSession } from "utils/endSession"
import { ROUTES } from "constants/routes"

const Logout = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    let cancelled = false

    const runLogout = async () => {
      try {
        await dispatch(logoutUser())
      } finally {
        endSession()
        if (!cancelled) {
          startTransition(() => {
            navigate(ROUTES.LOGIN, { replace: true })
          })
        }
      }
    }

    runLogout()

    return () => {
      cancelled = true
    }
  }, [dispatch, navigate])

  return null
}

export default Logout
